import { gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'

const query = gql`
  query fetchArticleCategories($page: Int!, $limit: Int!, $sort: String) {
    ArticleCategories(
      page: $page,
      limit: $limit,
      sort: $sort,
      where: { archived: { equals: false } }
    ) {
      docs {
        id
        name
        slug
      }
    }
  }
`

export enum ArticleCategorySort {
  NameAsc = 'name',
  NameDesc = '-name',
  CreatedAtAsc = 'createdAt',
  CreatedAtDesc = '-createdAt',
  UpdatedAtAsc = 'updatedAt',
  UpdatedAtDesc = '-updatedAt',
  PositionAsc = 'position',
  PositionDesc = '-position',
}

export interface CategoryTabsQueryInput {
  page: number
  limit: number
  sort: ArticleCategorySort
}

export interface CategoryTabsQueryOutput {
  ArticleCategories: {
    docs: {
      id: string
      name: string
      slug: string
    }[]
  }
}

export const useCategoryTabsQuery = (input: CategoryTabsQueryInput) =>
  usePersistedCacheQuery<CategoryTabsQueryOutput, CategoryTabsQueryInput>(query, { variables: input })
